import { h } from 'preact'
import EmptyPage from '../empty-page/EmptyPage'
import globals from '../../utils/globals'
import Overview from '../overview'
import UserCell from '../overview/cells/UserCell'
import DateCell from '../overview/cells/DateCell'
import TitleCell from '../overview/cells/TitleCell'
import ActionByUserCell from '../overview/cells/ActionByUserCell'
import IconCell from '../overview/cells/IconCell'
import { IdeationStatus, ModerationLabel, ModeratorTag } from '../overview/filters/types'
import {
  assignedModerator,
  ideationStatus,
  moderationLabel,
  moderatorTag,
  pinnedReply,
  separator,
  changedIdeationStatusAt
} from '../overview/filters/filters'

type Props = {
  moderationLabels: ModerationLabel[],
  moderatorTags: ModeratorTag[],
  ideationStatuses: IdeationStatus[]
}

const IdeationOverview = ({ moderationLabels, moderatorTags, ideationStatuses } : Props) => {
  function getFilters () {
    return [
      ideationStatus(ideationStatuses, true),
      moderationLabel(moderationLabels),
      moderatorTag(moderatorTags),
      assignedModerator(),
      separator(),
      pinnedReply(),
      changedIdeationStatusAt()
    ]
  }
  function getColumns () {
    return [
      { header: 'Title', accessor: 'title', cell: TitleCell(), size: 'xl', isFixed: true },
      { header: 'Votes', accessor: 'votes', size: 'xs-right', cell: IconCell('votes', 'triangle') },
      { header: 'Replies', accessor: 'replyCount', size: 'xs-right', cell: IconCell('replyCount', 'reply') },
      { header: 'Author', accessor: 'author', cell: UserCell('author') },
      { header: 'Publish date', accessor: 'publishedAt', cell: DateCell('publishedAt'), sorting: 'publishedAt' },
      { header: 'Last activity', accessor: 'lastActivity', cell: ActionByUserCell('lastActivity'), sorting: 'lastActivityAt', size: 'l' },
      { header: 'Last ideation status change', accessor: 'changedIdeationStatusAt', cell: DateCell('changedIdeationStatusAt'), sorting: 'changedIdeationStatusAt', size: 'l' }
    ]
  }

  return <Overview
    type='ideation'
    headerTitle='Ideas'
    withPagination={{
      page: 1,
      pageSize: 25
    }}
    withSorting={{
      lastActivityAt: 'desc'
    }}
    withFilters={getFilters()}
    withSearch
    searchPlaceholder='Search in title and content'
    withColumns
    rowId='id'
    model={getColumns()}
    endpoint='/idea/overview/topics'
    dataKey='topics'
    EmptyStateComponent={<EmptyPage
      img_src={`${globals('defaultCdn')}/images/empty_page.png`}
      header='There are no ideas yet'
      text={'Seems like no one on your team has created an idea. \n Start now by creating a new idea.'}
      button={{ link: '/content/new/idea', text: 'New idea' }}
    />}
  />
}

export default IdeationOverview
